export default {
  apiRoot: import.meta.env.VITE_INTERNAL_API_URL,
  geoApiRoot: import.meta.env.VITE_GEO_API_URL,
  activityApiRoot: import.meta.env.VITE_ACTIVITY_API_URL
}
